<script setup lang="ts">
import { NxtFormSection } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import SocialMediaFormSection from '@/apps/admin/components/forms/settings/SocialMediaFormSection.vue';
import AddressFormSection from '@/apps/admin/components/forms/settings/AddressFormSection.vue';
import PolicyFormSection from '@/apps/admin/components/forms/settings/PolicyFormSection.vue';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <div>
      <NxtFormSection :title="$t('job-board.settings.contactdetails')">
         <AddressFormSection v-model="jobBoard" />
      </NxtFormSection>

      <NxtFormSection :title="$t('job-board.settings.social_media.social_media')">
         <SocialMediaFormSection v-model="jobBoard" />
      </NxtFormSection>

      <NxtFormSection :title="$t('job-board.settings.policies')">
         <PolicyFormSection v-model="jobBoard" />
      </NxtFormSection>
   </div>
</template>
